import { render } from "./receipt-list-item.vue?vue&type=template&id=51e6c88e"
import script from "./receipt-list-item.vue?vue&type=script&lang=js"
export * from "./receipt-list-item.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__